module.exports = __webpack_public_path__ + "static/media/icon-additional.00d2001b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-additional.svg
// module id = 637
// module chunks = 0